module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "padded"
  }, [_c('el-tabs', {
    attrs: {
      "type": "border-card"
    },
    model: {
      value: (_vm.active),
      callback: function($$v) {
        _vm.active = $$v
      },
      expression: "active"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "name": "table"
    }
  }, [_c('template', {
    slot: "label"
  }, [_c('span', {
    staticClass: "text-primary"
  }, [_c('i', {
    staticClass: "header-icon fa fa-stopwatch"
  }, [_vm._v(" ")]), _vm._v("Expiring Sites")])]), _vm._v(" "), _c('expiry-table')], 2), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "name": "map",
      "lazy": ""
    }
  }, [_c('template', {
    slot: "label"
  }, [_c('span', {
    staticClass: "text-primary"
  }, [_c('i', {
    staticClass: "header-icon fa fa-map-marker"
  }, [_vm._v(" ")]), _vm._v("Map")])]), _vm._v(" "), _c('tenancy-expiry-map')], 2)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0c820b82"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard/property/PropertyExpiry.vue
// module id = 1317
// module chunks = 0